import React, { useEffect, useState } from 'react';

import styles from "./CardDesignSelect.module.css";
import { useTranslation } from 'react-i18next';

type CardDesignOptionProps = {
  screenId: string;
  cardProductCode?: string;
  designDivisionCode: string;
  isSelected?: boolean;
  onClick?: () => void;
}

const CardDesignOption: React.FC<CardDesignOptionProps> = ({screenId, cardProductCode , designDivisionCode, isSelected, onClick}) => {
  const { t } = useTranslation();

  const [cardDesignUrl, setCardDesignUrl] = useState<string>();

  const [optionHeader, setOptionHeader] = useState("");
  const [optionContent, setOptionContent] = useState("");

  const handleOptionClick = () => {
    onClick?.();
  }

  useEffect(() => {
    // "https://devcard.gmoneytrans.net/images/products/gmoney-card_100921_B.png"
    setCardDesignUrl(localStorage.getItem(`${cardProductCode}_${designDivisionCode}`) as string);

    if (designDivisionCode === "C") {
      setOptionHeader(t(`${screenId}.TEXT_3`, "Hanguel Card"));
      setOptionContent(t(`${screenId}.TEXT_4`, "This design embodies Hangeul, the world's only unique alphabet, directly represetnting Krea and capturing its beauty."));
    } else if (designDivisionCode === "B") {
      setOptionHeader(t(`${screenId}.TEXT_5`, "Dancheong Card"));
      setOptionContent(t(`${screenId}.TEXT_6`, "Traditional Korean architecture, this design represents prosperity and longevity, carrying wishes for happiness."));
    }
// eslint-disable-next-line
  }, [cardProductCode, designDivisionCode]);

  return (
    <div className={styles.cardDesignOption} onClick={handleOptionClick}>
      <img className={`${styles.image} ${isSelected !== undefined && !isSelected ? styles.unselected: ""}`} alt={"Card Product"} src={cardDesignUrl + "?v=1"}/>
      <img className={styles.radioButton} alt={"Card Product Select Radio Button"} src={isSelected ? "/assets/images/ico/ic_radio_selected_24.png" : "/assets/images/ico/ic_radio_unselected_24.png"}></img>
      <img className={`${styles.headerIcon} ${isSelected !== undefined && !isSelected ? styles.unselected: ""}`} alt={"Double Quote Icon"} src={"/assets/images/ico/double_quote.png"}/>
      <div className={`${styles.header} ${isSelected !== undefined && !isSelected ? styles.unselected: ""}`}>{optionHeader}</div>
      <div className={`${styles.content} ${isSelected !== undefined && !isSelected ? styles.unselected: ""}`}>{optionContent}</div>
    </div>
  );
}

export default CardDesignOption;